import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaCamera,
  FaImage,
  FaPhone,
  FaFilePdf,
  FaYoutube,
  FaFileExcel,
  FaFileAlt,
} from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import pdficon from "./images/pdficon.png";
import videoicon from "./images/videoicon.webp";
import { FaPhoneAlt } from "react-icons/fa";
import { useNotification } from '../context/NotificationContext';


const ProjectQuotePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryId, categoryName, projectId } = location.state || {};
  console.log('categoryId', categoryId);
  console.log('categoryName', categoryName);
  console.log('projectId',projectId);

  const [loading, setLoading] = useState(true);
  const [quotesRequested, setQuotesRequested] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [brandStatus, setBrandStatus] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [vendorsData, setVendorsData] = useState([]);
  const [rfqsData, setRfqsData] = useState([]);
  const fileInputRef = React.useRef(null);
  const cameraInputRef = React.useRef(null);
const [showVideo, setShowVideo] = useState(false);
  const { notifications, setNotifications } = useNotification();
  console.log("Notifications in ProjectQuote:", notifications);

  const [newQuotationMode, setNewQuotationMode] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  
const [openVideoVendorId, setOpenVideoVendorId] = useState(null);
const [quotesButtonClicked, setQuotesButtonClicked] = useState(false);
const [visibleVendors, setVisibleVendors] = useState(0);
const [mobile, setmobile] = useState("");

useEffect(() => {
  if (quotesButtonClicked && rfqsData.length > 0) {
    setVisibleVendors(1); // show first vendor immediately
    let i = 1;
    const interval = setInterval(() => {
      i++;
      if (i <= rfqsData.length) {
        setVisibleVendors(i);
      } else {
        clearInterval(interval);
      }
    }, 10000); // 10 sec gap
    return () => clearInterval(interval);
  }
}, [quotesButtonClicked, rfqsData]);

const handleGetQuotesClick = async () => {
  setQuotesButtonClicked(true);

  if (categoryId) sessionStorage.setItem("rfq_categoryId", categoryId);
  if (categoryName) sessionStorage.setItem("rfq_categoryName", categoryName);
  if (projectId) sessionStorage.setItem("rfq_projectId", projectId);

  // mark that project quote should show
  sessionStorage.setItem("showProjectQuote", "true");

  // run request
  await handleGetQuotes();

  // navigate("/consumer/projectdetails", {
  //   state: { defaultTab: "buy" },
  // });
};


// 👇 add this inside your component
useEffect(() => {
  if (notifications && notifications.length > 0) {
    console.log("📩 New Notification Arrived:", notifications[0]);

    // whenever new notification comes, fetch RFQs by category
    fetchCustomerRFQsBycategory();

    // show Status div
    setShowStatus(true);

    // hide Brand Quotations until status shown
    setNewQuotationMode(true);
  }
}, [notifications]);


  const getFileIcon = (fileName) => {
    if (!fileName) return <FaFileAlt className="w-5 h-5 text-gray-600" />;
    const ext = fileName.split(".").pop().toLowerCase();
    switch (ext) {
      case "pdf":
return <img src={pdficon} className="w-5 h-5" alt="PDF" />;
      case "xls":
      case "xlsx":
        return <FaFileExcel className="w-5 h-5 text-green-600" />;
      case "mp4":
      case "mov":
      case "avi":
      case "mkv":
return <img src={videoicon} className="w-5 h-5" alt="Video" />;
      default:
        return <FaFileAlt className="w-5 h-5 text-gray-600" />;
    }
  };

  const getFullFileUrl = (filePath) => {
    if (!filePath) return "";
    const cleanPath = filePath.replace(/[\[\]]/g, "").trim();
    const normalized = cleanPath.replace(/^\/+/, "");
    const base = process.env.REACT_APP_FORE_BRICKBUCKET?.replace(/\/+$/, "");
    return `${base}/${normalized}`;
  };

  useEffect(() => {
    fetchVendorsByProductCategoryId();
    fetchCustomerRFQsBycategory();
  }, []);

 

  const fetchVendorsByProductCategoryId = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}manufacturer/get-manufacturers-by-categoryId?product_category_id=${categoryId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );
      const result = await response.json();
      console.log("Vendors fetched:", result);
      if (response.ok && result.success) {
        setVendorsData(result.data);
      } else {
        console.error("Failed to fetch vendors:", result.message);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };

const fetchCustomerRFQs = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const customerId = sessionStorage.getItem("customerId");

    console.log("slectedBrands:", selectedBrands);
    // collect brand IDs from selectedBrands
    const brandIds = selectedBrands.map((b) => b._id);

    const bodyPayload = {
      customerId: customerId,
      projectId: projectId,   // make sure projectId is defined in state/props
      categoryId: categoryId, // same for categoryId
      brandIds: brandIds,     // must be an array, even if empty
    };

    console.log("body sent:", bodyPayload);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-customer-rfqs`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(bodyPayload),
      }
    );

    const result = await response.json();
    console.log("RFQs fetched:", result);

    if (response.ok && result.success && result.data.length > 0) {
      setRfqsData(result.data);
      setQuotesRequested(true);
    } else {
      setQuotesRequested(false);
    }
  } catch (error) {
    console.error("Error fetching RFQs:", error);
    setQuotesRequested(false);
  }
};


  const fetchCustomerRFQsBycategory = async () => {
  try {
    setLoading(true);
    const token = sessionStorage.getItem("token");
    const customerId = sessionStorage.getItem("customerId");

    const bodyPayload = {
      customerId: customerId,
      projectId: projectId,
      categoryId: categoryId,
    };

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-customer-rfqs-by-category`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(bodyPayload),
      }
    );

    const result = await response.json();
    console.log("RFQs fetched:", result);

    if (response.ok && result.success && result.data.length > 0) {
      setRfqsData(result.data);
      setQuotesRequested(true);
    } else {
      setRfqsData([]);
      setQuotesRequested(false);
    }
  } catch (error) {
    console.error("Error fetching RFQs:", error);
    setQuotesRequested(false);
  }
  finally {
    setLoading(false);
  }
};



  const toggleBrandSelection = (brand) => {
    setSelectedBrands((prev) =>
      prev.find((b) => b._id === brand._id)
        ? prev.filter((b) => b._id !== brand._id)
        : [...prev, brand]
    );
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleGetQuotes = async () => {
  if (selectedBrands.length === 0 || !selectedImage) return;

  try {
    const token = sessionStorage.getItem("token");
    const customerId = sessionStorage.getItem("customerId");

    const formData = new FormData();
    formData.append("customerId", customerId);
    formData.append("categoryId", categoryId);
    formData.append("projectId", projectId);

    // Append each brandId separately (backend can handle as array)
    formData.append("brandIds", JSON.stringify(selectedBrands.map(b => b._id)));

    console.log("Selected brands:", selectedBrands);

    // Append file (either from camera or gallery)
    const fileInput = fileInputRef.current?.files?.[0] || cameraInputRef.current?.files?.[0];
    if (fileInput) {
      formData.append("images", fileInput); // <-- this name should match your multer field in backend
    }

    console.log("FormData being sent:", formData);
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}manufacturer/request-for-project-quote`,
      {
        method: "POST",
        headers: {
          "x-token": token,
          // Do NOT set Content-Type; browser will set it automatically for FormData
        },
        body: formData,
      }
    );

    const result = await response.json();
    console.log("Request quotes response:", result);

   if (response.ok && result.success) {
      // ✅ If rfqCount === 0 → show alert
      // if (result.rfqCount === 0) {
      //   alert("Sales rep not created. Please create a Sales Rep first.");
      //   return;
      // }
      //fetchCustomerRFQs();
/*        setTimeout(() => {
        fetchCustomerRFQsBycategory();
      }, 2 * 60 * 1000);
       setQuotesRequested(true); */
      setShowStatus(true);
    } else {
      console.error("Failed to request quotes:", result.message);
    }
  } catch (error) {
    console.error("Error while requesting quotes:", error);
  }
};

  const requestVendorCall = async (vendorId) => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}manufacturer/request-call`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
          body: JSON.stringify({ vendorId }),
        }
      );
      const result = await response.json();
      console.log("Request call response:", result);
      setmobile(result.data.mobile);
      if (!(response.ok && result.success)) {
        alert("Could not fetch vendor mobile.");
      }
    } catch (error) {
      alert("Something went wrong.");
    }
  };

if (loading) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400  text-xs">Loading ProjectQuote...</p>
    </div>
  );
} 


return (
  <div className="min-h-screen bg-gray-50">
    {/* === Header === */}
    <div className="flex items-center gap-3 px-4 py-3 border-b bg-white shadow-sm">
      <button
        className="text-gray-600 text-sm"
        onClick={() =>
          navigate("/consumer/projectdetails", {
            state: { defaultTab: "buy" }
          })
        }
      >
        <FaArrowLeft size={20} />
      </button>
      <h1 className="text-md font-medium text-[#000000]">Project Quotes</h1>
    </div>

    <div className="p-4 space-y-4 max-w-4xl mx-auto">

      {/* === CASE 1: If RFQs exist on initial load → Only Vendor Cards + Banner === */}
      {rfqsData.length > 0 && !quotesButtonClicked ? (
        <>

         <h2 className="text-base font-semibold text-gray-800 mb-3 px-1">
      Brand Quotes
    </h2>
          {/* Vendor Cards */}
          {rfqsData.map((item, idx) => (
            <div
              key={item?.vendor?.id || idx}
              className="bg-white rounded-xl border shadow-sm p-3 mb-4"
            >
              {/* === Vendor Info === */}
              <div className="flex justify-between items-center mb-2">
                <div className="flex items-center text-left gap-2">
                  {item?.vendor?.image ? (
                    <img
                      src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}/${item.vendor.image}`}
                      alt={item.vendor?.name || "Vendor"}
                      className="h-12 w-12 object-contain"
                    />
                  ) : (
                    <div className="h-12 w-12 flex items-center justify-center border rounded text-xs text-gray-500">
                      No Image
                    </div>
                  )}
                  {/* <p className="text-sm font-semibold text-gray-800">
                    {item?.vendor?.name || "Unknown Vendor"}
                  </p> */}
                </div>
                <div className="text-right">
                 {item?.rfqs[0]?.discount > 0 && (
  <div className="text-right">
    <p className="text-xs text-gray-700">
      Discount:{" "}
      <span className="text-gray-600 text-sm font-medium">
        {`${item?.rfqs[0]?.discount} %`}
      </span>
    </p>
  </div>
)}

                </div>
              </div>

              {/* === RFQs === */}
           {Array.isArray(item?.rfqs) && item.rfqs.length > 0 && (
      <div className="flex items-start gap-3 mb-1 p-1">
        <span className="w-20 text-xs font-medium text-gray-800">
          Quotations
        </span>
        <div className="flex flex-wrap gap-2">
          {item.rfqs.map((rfq, rfqIdx) =>
            Array.isArray(rfq.files)
              ? rfq.files.map((filePath, fileIdx) => {
                  const rawName = filePath.split("/").pop();
                  // === truncate if more than 15 characters ===
                  const displayName =
                    rawName.length > 10
                      ? rawName.substring(0, 10) + ".."
                      : rawName;

                  return (
                    <div
                      key={`${rfqIdx}-${fileIdx}`}
                      className="flex flex-col items-center w-24"
                    >
                      <a
                        href={getFullFileUrl(filePath)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-6 h-6 flex items-center justify-center border border-gray-300 rounded-md"
                        title={rawName}
                      >
                        {getFileIcon(rawName)}
                      </a>
                      <span
                        className="text-[9px] truncate text-center text-gray-700"
                        title={rawName}
                      >
                        {displayName}
                      </span>
                    </div>
                  );
                })
              : null
          )}
        </div>
      </div>

      
    )}

    {/* === Catalogue === */}
    {item?.catalogue?.files && (
      <div className="flex items-start gap-3 mb-1 p-1">
        <span className="w-20 text-xs font-medium text-gray-800">
          Catalogue
        </span>
        <div className="flex flex-wrap gap-2">
          {item.catalogue.files
            .replace(/[\[\]]/g, "")
            .split(",")
            .map((filePath, idx) => {
              const rawName = filePath.split("/").pop();
              const displayName =
                rawName.length > 15
                  ? rawName.substring(0, 15) + ".."
                  : rawName;

              return (
                <div key={idx} className="flex flex-col items-center w-24">
                  <a
                    href={getFullFileUrl(filePath)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center"
                    title={rawName}
                  >
                    <div className="w-6 h-6 flex items-center justify-center border border-gray-300 rounded-md hover:bg-gray-100">
                      {getFileIcon(rawName)}
                    </div>
                    <span className="text-[10px] truncate text-center text-gray-700 hover:text-gray-900 mt-1">
                      {displayName}
                    </span>
                  </a>
                </div>
              );
            })}
        </div>
      </div>
    )}

    {/* === Product Video === */}
    {item?.productVideos?.video_link && (
      <div className="mb-4">
        <div className="flex items-center gap-12 mb-1 p-1">
          <span className="w-20 text-xs font-medium text-gray-800">
            Product Video
          </span>
          <img
            src={videoicon}
            className="w-6 h-6 cursor-pointer rounded-md border border-gray-300"
            alt="Video"
            onClick={() => setShowVideo((prev) => !prev)}
          />
        </div>

        {showVideo && (
          <div className="relative w-full mt-0 rounded-md overflow-hidden">
            <iframe
              className="w-full aspect-video"
              src={`https://www.youtube.com/embed/${
                item.productVideos.video_link.includes("youtu.be/")
                  ? item.productVideos.video_link.split("youtu.be/")[1]
                  : item.productVideos.video_link.split("watch?v=")[1]
              }`}
              title="Video Player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>
    )}


    <button
      onClick={() => {
        requestVendorCall(item?.vendor?.id);
        const phoneNumber = mobile;
        if (phoneNumber) {
          const link = document.createElement("a");
          link.href = `tel:${phoneNumber}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }}
      className="w-full flex items-center justify-center gap-2 py-2 text-xs font-medium bg-gray-100 border rounded-lg text-gray-700 hover:bg-gray-50"
    >
      <FaPhoneAlt /> Call to Talk
    </button>

   


            </div>
          ))}

          {/* Banner */}
          <div className="bg-gray-100 border border-gray-300 rounded-lg p-2 text-xs text-gray-700 mt-2">
            🎉 Earn Upto <b>₹1000 BuildCoins</b> in your wallet when you buy from any of
            the above brands and upload a GST invoice.
          </div>
        </>
      ) : (
        /* === CASE 2: No RFQs on initial load → Show Form === */
        <>
          {/* === Category === */}
          <h2 className="text-md font-semibold text-[#000000] mb-4">
            {categoryName || "Category"}
          </h2>

          {/* === Brand Selection === */}
          <div className="bg-white rounded-xl border p-4 mb-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-semibold text-gray-700">
                Select Brands
              </h3>
              {vendorsData.length > 0 && (
                <button
                  className="text-xs font-medium text-gray-700"
                  onClick={() => {
                    if (selectedBrands.length === vendorsData.length) {
                      setSelectedBrands([]);
                    } else {
                      setSelectedBrands(vendorsData);
                    }
                  }}
                >
                  {selectedBrands.length === vendorsData.length
                    ? "Unselect All"
                    : "Select All"}
                </button>
              )}
            </div>
            {vendorsData.length > 0 ? (
              <div className="grid grid-cols-3 gap-3">
                {vendorsData.map((vendor) => {
                  const isSelected = selectedBrands.find(
                    (sb) => sb._id === vendor._id
                  );
                  return (
                    <div
                      key={vendor._id}
                      className={`relative flex flex-col items-center justify-center p-3 rounded-lg border cursor-pointer transition ${
                        isSelected
                          ? "border-gray-400 bg-gray-50"
                          : "border-gray-200 bg-white hover:border-gray-300"
                      }`}
                      onClick={() => toggleBrandSelection(vendor)}
                    >
                     {vendor.image ? (
  <img
    src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}/${vendor.image}`}
    alt={vendor.name}
    className="h-8 object-contain mb-1"
    onError={(e) => {
      e.currentTarget.onerror = null; 
      e.currentTarget.style.display = "none";
      e.currentTarget.insertAdjacentHTML(
        "afterend",
        `<div class="flex flex-col items-center justify-center text-gray-400 text-[10px] leading-tight mb-1">
          <span>No</span>
          <span>Image</span>
        </div>`
      );
    }}
  />
) : (
  <div className="flex flex-col items-center justify-center text-gray-400 text-[10px] leading-tight mb-1">
    <span>No</span>
    <span>Image</span>
  </div>
)}

                      <p className="text-[11px] font-medium text-gray-700 text-center">
                        {vendor.name}
                      </p>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-xs text-gray-400 text-center py-4">
                No brands available
              </p>
            )}
          </div>

          {/* === Upload Requirement === */}
          <div className="bg-white rounded-xl border p-4 mb-4">
            {!selectedImage ? (
              <>
                <h3 className="text-sm font-semibold mb-3 text-gray-700">
                  Upload Project Requirement
                </h3>
                <div className="flex gap-3">
                  <button
                    onClick={() => cameraInputRef.current.click()}
                    className="flex-1 flex flex-col items-center justify-center p-4 border border-dashed border-gray-300 rounded-lg hover:border-gray-400 transition"
                  >
                    <FaCamera className="text-gray-500 text-lg mb-1" />
                    <span className="text-xs text-gray-600">Click a Photo</span>
                  </button>
                  <button
                    onClick={() => fileInputRef.current.click()}
                    className="flex-1 flex flex-col items-center justify-center p-4 border border-dashed border-gray-300 rounded-lg hover:border-gray-400 transition"
                  >
                    <FaImage className="text-gray-500 text-lg mb-1" />
                    <span className="text-xs text-gray-600">
                      Select from Gallery
                    </span>
                  </button>
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    ref={cameraInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </div>
              </>
            ) : (
              <div className="flex flex-col gap-2">
                <p className="text-xs text-gray-500">
                  Uploaded Project Requirement
                </p>
                <div
                  className="w-12 h-12 flex items-center justify-center cursor-pointer"
                  onClick={() => setShowPreview(true)}
                >
                  <img
                    src={selectedImage}
                    alt="preview"
                    className="w-12 h-12 object-cover rounded-md"
                  />
                </div>
              </div>
            )}
          </div>

          {/* === Get Quotes Button === */}
          {!quotesButtonClicked && (
            <button
              disabled={selectedBrands.length === 0 || !selectedImage}
              onClick={handleGetQuotesClick}
              className={`w-full py-3 rounded-lg text-white font-medium ${
                selectedBrands.length > 0 && selectedImage
                  ? "bg-red-400"
                  : "bg-gray-200 text-gray-600 cursor-not-allowed"
              }`}
            >
              Get Project Quotes
            </button>
          )}

 {quotesButtonClicked && (
  <div className="border border-gray-300 rounded-lg p-4 bg-white w-full max-w-sm mx-auto flex flex-col items-center space-y-2 mb-4">
    
    {/* Case 1: no vendors yet → only "Request sent" + waiting */}
    {rfqsData.length === 0 ? (
      <>
        <p className="text-sm text-gray-700 text-center">Request sent</p>
        <p className="text-sm text-gray-500 text-center">Waiting for response...</p>
      </>
    ) : visibleVendors < rfqsData.length ? (
      <>
        {/* Case 2: some vendors accepted → keep Request sent + show names */}
        <p className="text-sm text-gray-700 text-center">Request sent</p>
        <p className="text-sm text-gray-500 text-center">
          {rfqsData.slice(0, visibleVendors).map(v => v.vendor?.name).join(", ")}{" "}
          {visibleVendors === 1
            ? "brand accepted. Waiting for more brands..."
            : "brands accepted. Wait for other brands."}
        </p>
      </>
    ) : (
      /* Case 3: all vendors accepted → hide Request sent */
      <p className="text-sm font-medium text-green-600 text-center">
        All brands accepted 
      </p>
    )}
  </div>
)}






          {/* === After Quotes Requested → Show Status + Vendor Cards + Banner === */}
        {quotesButtonClicked && rfqsData.length > 0 && (
  <>
    {/* Vendor Cards → progressive reveal */}
    {rfqsData.slice(0, visibleVendors).map((item, idx) => (
      <div
        key={item?.vendor?.id || idx}
        className="bg-white rounded-xl border shadow-sm p-3 mb-4"
      >
        {/* === Vendor Info === */}
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center text-left gap-2">
            {item?.vendor?.image ? (
              <img
                src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}/${item.vendor.image}`}
                alt={item.vendor?.name || "Vendor"}
                className="h-12 w-12 object-contain"
              />
            ) : (
              <div className="h-12 w-12 flex flex-col items-center justify-center border rounded text-[10px] text-gray-500 leading-tight text-center">
                <span>No</span>
                <span>Image</span>
              </div>
            )}
          </div>

          {/* Right side: discount */}
          {item?.rfqs[0]?.discount > 0 && (
            <div className="text-right">
              <p className="text-xs text-gray-700">
                Discount:{" "}
                <span className="text-gray-600 text-sm font-medium">
                  {`${item?.rfqs[0]?.discount} %`}
                </span>
              </p>
            </div>
          )}
        </div>

        {/* === RFQs === */}
        {Array.isArray(item?.rfqs) && item.rfqs.length > 0 && (
          <div className="flex items-start gap-3 mb-1 p-1">
            <span className="w-20 text-xs font-medium text-gray-800">
              Quotations
            </span>
            <div className="flex flex-wrap gap-2">
              {item.rfqs.map((rfq, rfqIdx) =>
                Array.isArray(rfq.files)
                  ? rfq.files.map((filePath, fileIdx) => {
                      const rawName = filePath.split("/").pop();
                      const displayName =
                        rawName.length > 10
                          ? rawName.substring(0, 10) + ".."
                          : rawName;

                      return (
                        <div
                          key={`${rfqIdx}-${fileIdx}`}
                          className="flex flex-col items-center w-24"
                        >
                          <a
                            href={getFullFileUrl(filePath)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-6 h-6 flex items-center justify-center border border-gray-300 rounded-md"
                            title={rawName}
                          >
                            {getFileIcon(rawName)}
                          </a>
                          <span
                            className="text-[9px] truncate text-center text-gray-700"
                            title={rawName}
                          >
                            {displayName}
                          </span>
                        </div>
                      );
                    })
                  : null
              )}
            </div>
          </div>
        )}

        {/* === Catalogue === */}
        {item?.catalogue?.files && (
          <div className="flex items-start gap-3 mb-1 p-1">
            <span className="w-20 text-xs font-medium text-gray-800">
              Catalogue
            </span>
            <div className="flex flex-wrap gap-2">
              {item.catalogue.files
                .replace(/[\[\]]/g, "")
                .split(",")
                .map((filePath, idx) => {
                  const rawName = filePath.split("/").pop();
                  const displayName =
                    rawName.length > 15
                      ? rawName.substring(0, 15) + ".."
                      : rawName;

                  return (
                    <div key={idx} className="flex flex-col items-center w-24">
                      <a
                        href={getFullFileUrl(filePath)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center"
                        title={rawName}
                      >
                        <div className="w-6 h-6 flex items-center justify-center border border-gray-300 rounded-md hover:bg-gray-100">
                          {getFileIcon(rawName)}
                        </div>
                        <span className="text-[10px] truncate text-center text-gray-700 hover:text-gray-900 mt-1">
                          {displayName}
                        </span>
                      </a>
                    </div>
                  );
                })}
            </div>
          </div>
        )}

        {/* === Product Video === */}
        {item?.productVideos?.video_link && (
          <div className="mb-4">
            <div className="flex items-center gap-12 mb-1 p-1">
              <span className="w-20 text-xs font-medium text-gray-800">
                Product Video
              </span>
              <img
                src={videoicon}
                className="w-6 h-6 cursor-pointer rounded-md border border-gray-300"
                alt="Video"
                onClick={() => setShowVideo((prev) => !prev)}
              />
            </div>

            {showVideo && (
              <div className="relative w-full mt-0 rounded-md overflow-hidden">
                <iframe
                  className="w-full aspect-video"
                  src={`https://www.youtube.com/embed/${
                    item.productVideos.video_link.includes("youtu.be/")
                      ? item.productVideos.video_link.split("youtu.be/")[1]
                      : item.productVideos.video_link.split("watch?v=")[1]
                  }`}
                  title="Video Player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </div>
        )}

        <button
          onClick={() => {
            requestVendorCall(item?.vendor?.id);
            const phoneNumber = mobile;
            if (phoneNumber) {
              const link = document.createElement("a");
              link.href = `tel:${phoneNumber}`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }}
          className="w-full flex items-center justify-center gap-2 py-2 text-xs font-medium bg-gray-100 border rounded-lg text-gray-700 hover:bg-gray-50"
        >
          <FaPhoneAlt /> Call to Talk
        </button>
      </div>
    ))}

    {/* Banner */}
   
  </>
)}

 {rfqsData.length > 0 && visibleVendors === rfqsData.length && (
  <div className="bg-gray-100 border border-gray-300 rounded-lg p-2 text-xs text-gray-700 mt-2">
    🎉 Earn Upto <b>₹1000 BuildCoins</b> in your wallet when you buy from any of
    the above brands and upload a GST invoice.
  </div>
)}

        </>
      )}
    </div>

    {/* === Image Preview Modal === */}
    {showPreview && (
      <div
        className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
        onClick={() => setShowPreview(false)}
      >
        <img
          src={selectedImage}
          alt="Full Preview"
          className="max-w-[90%] max-h-[90%] rounded-lg shadow-lg"
        />
      </div>
    )}
   
  </div>
);


  
};
export default ProjectQuotePage;
